export const errorMessage = (error: any) => {
  return error?.response?.data?.Message || error?.Message ||
  error?.response?.data?.message ||
  error?.response?.data?.title ||
  error?.message
}